module.exports = __webpack_public_path__ + "img/logo_1.93a91673.png";